import { Icon } from "@iconify/react";
import { Grid, TextField } from "@mui/material";
import React from "react";
import DatePicker from "../../orders/components/DatePicker";
import { getDateDescription } from "../../orders/utils/getDateDescription";
import moment from "moment";

export default function TopHeader({ windowWidth, selectDate, setSelectDate, userName }) {
  return (
    <Grid
      container
      spacing={windowWidth <= 1700 ? 2 : 4}
      sx={{ padding: "0 20px", marginBottom: "10px" }}
    >
      <Grid item xs={6}>
        <h4 style={{ color: "white" }}>Welcome {userName},</h4>
        <h6 style={{ marginTop: "10px", color: "white" }}>
          {moment().format('dddd, D MMM, YYYY')}
        </h6>
      </Grid>
      <Grid item xs={3} sx={{ display: "flex", justifyContent: "flex-end" }}>
        <div>
          {/* <YearPicker type="Yesterday" /> */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              cursor: "pointer",
              position: "relative",
                zIndex:999
            }}
          >
            <div
              style={{
                padding: "10px",
                background: "#1d0d31",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                color: "white",
                width: "150px",
                
              }}
            >
              <div
                style={{
                  position: "absolute",
                  opacity: 0,
                  width: "100%",
                  background: "#1d0d31",
                  transform: "scaleX(-1)"
                }}
              >
                <DatePicker
                  title="End Date"
                  sx={{ width: "100%" }}
                  value={selectDate}
                  renderInput={(params) => <TextField {...params} />}
                  onChange={(newValue) => setSelectDate(newValue?.$d)}
                />
              </div>
              <Icon icon="formkit:date" style={{ color: "white" }} />
              <h6 style={{ margin: 0, cursor:'pointer' }}>{getDateDescription(selectDate)}</h6>
            </div>
          </div>
          <h6 style={{ color: "white", fontSize: "12px" }}>
            % compared to the day before
          </h6>
        </div>
      </Grid>
      <Grid item xs={3}></Grid>
    </Grid>
  );
}
